import React, { useEffect, useState, useCallback } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import {
  Typography,
  Button,
  Breadcrumbs,
  Link,
  AppBar,
  Toolbar,
  IconButton,
  Chip,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";
import { Alert } from "reactstrap";
import {
  // convertTimestampToUTC,
  convertTimestampToUTCAndLocalTime,
  convertToBrowserDateAsDate,
  convertToBrowserDateAsSeconds,
  convertToUTCDateFromMilliseconds,
} from "./../../../utilities/dateConversion";

import {
  getOrgAccounts,
  updateOrgAccount,
  deleteOrgAccount,
  deleteOrgUser,
  clearAllOrgAcctMessages,
  clearAllOrgUserMessages,
  getLicense,
  clearAllGlobalLicenseMessages,
  getCustomLicenses,
  clearAllCustomLicenseMessages,
  getOrgAccountWorkloads,
  updateOrgAccountWorkload,
  getScanSchedules,
  updateScanScheduleFrequency,
} from "../../../store/actions";
import { makeStyles } from "@mui/styles";

import { Link as RouterLink } from "react-router-dom";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import accessToken from "../../../helpers/jwt-token-access/accessToken";
import { jwtDecode } from "jwt-decode";
import { UserModal } from "./UserModal";
import { ComplianceAddOnsModal } from "./ComplianceAddOnsModal";
import AdditionalAddonsModal from "./AdditionalAddonsModal";
import { UserGroupModal } from "./UserGroupModal";
import { ResourceGroupModal } from "./ResourceGroupModal";
import UpdateOrganizationAccount from "./UpdateOrganizationAccount";
import AWSMarketplaceModal from "./AWSMarketplaceModal";
import SubscriptionModal from "./SubscriptionModal";
import { Info } from '../../../theme/icons';
import AddOrganizationAccount from "./AddOrganizationAccount";
import {
  FiberManualRecordIcon,
  LockIcon,
  LockOpenIcon,
  EditIcon,
  DeleteIcon,
  AddCircleIcon,
  SendIcon,
  ExtendIcon,
  IaacIcon,
  OutboundIcon,
  CloseIcon,
} from '../../../theme/icons';
import SettingsIcon from '@mui/icons-material/Settings';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { SnackbarProvider, enqueueSnackbar } from "notistack";
import spinner from "../../../assets/images/loadingGif.gif";
import AddUserModal from "./AddUserModal";
import EditUserModal from "./EditUserModal";
import WorkloadModal from "./WorkloadModal";
import ScanScheduleModal from "./ScanScheduleModal";
import { LoadingSpinner } from '../../../components/shared/LoadingSpinner';

const useStyles = makeStyles((theme) => ({
  appBar: {
    backgroundColor: "whitesmoke",
  },
  activeButton: {
    color: "white", // change this to the desired active color
    marginLeft: "auto", // This will push the link to the right
    textDecoration: "none", // Remove text decoration from the link
  },
  logo: {
    maxWidth: 160,
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    overflowY: "auto" /* Enable vertical scrolling */,
    maxHeight: "100vh" /* Set a maximum height to limit scrolling */,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

const dateOptions = {
  year: "numeric",
  month: "short",
  day: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  // timeZoneName: 'short' // optional
};

const OrganizationAccount = (props) => {
  console.log("OrganizationAccount props: ", props);
  const { orgCode } = useParams();
  const appBarStyles = {
    backgroundColor: "whitesmoke",
    // Add more custom styles as needed
  };
  const token = accessToken();
  const decoded = jwtDecode(token);
  const userRole = decoded["cognito:groups"];

  const classes = useStyles();

  // For Viewing Users Modal
  const [viewUserIsOpen, setViewUserIsOpen] = useState(false);
  const [users, setUsers] = useState(null);

  // For Viewing Compliance Modal
  const [viewComplianceAddOnsIsOpen, setViewComplianceAddOnsIsOpen] =
    useState(false);
  const [viewAddonsIsOpen, setViewAddOnsIsOpen] = useState(false);
  const [addons, setAddons] = useState(null);
  const [additionalAddons, setAdditionalAddons] = useState(null);

  // For Viewing Update Account (Subscription) Modal
  const [isUpdateAccountOpen, setIsUpdateAccountOpen] = useState(false);
  const [subscription, setSubscription] = useState(null);
  const [orgAccountCode, setOrgAccountCode] = useState(null);
  const [subscriptionExpirationDate, setSubscriptionExpirationDate] =
    useState(null);

  // For Adding and Editing users
  const [addUserIsOpen, setAddUserIsOpen] = useState(false);
  const [editUserIsOpen, setEditUserIsOpen] = useState(false);
  const [editUserData, setEditUserData] = useState(null);

  // For showing uer groups in a modal
  const [viewUserGroupIsOpen, setViewUserGroupIsOpen] = useState(false);
  const [userGroups, setUserGroups] = useState(null);
  const [userName, setUserName] = useState(null);

  // For showing resource groups in a modal
  const [viewResourceGroupIsOpen, setViewResourceGroupIsOpen] = useState(false);
  const [resourceGroups, setResourceGroups] = useState(null);
  const [accountName, setAccountName] = useState(null);

  // For showing AWSMarketplace Modal
  const [marketplaceDetails, setMarketplaceDetails] = useState(null);
  const [isMarketplaceModalOpen, setViewMarketplaceDetailsOpen] =
    useState(false);

  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = useState(false);
  const [addOrgAccountIsOpen, setAddOrgAccountIsOpen] = useState(false);

  // For Workload Modal
  const [isWorkloadModalOpen, setIsWorkloadModalOpen] = useState(false);
  const [selectedAccountNumber, setSelectedAccountNumber] = useState(null);

  // For Scan Schedule Modal
  const [isScanScheduleModalOpen, setIsScanScheduleModalOpen] = useState(false);
  const [selectedOrgCode, setSelectedOrgCode] = useState(null);
  const [selectedAccountCode, setSelectedAccountCode] = useState(null);
  const [selectedScanScheduleAccountNumber, setSelectedScanScheduleAccountNumber] = useState(null);
  const [selectedScanScheduleAccountName, setSelectedScanScheduleAccountName] = useState(null);

  // For Delete Confirmation Dialog
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [accountToDelete, setAccountToDelete] = useState(null);

  const handleOpenSubscriptionModal = (subscription) => {
    setSubscriptionDetails(subscription);
    setIsSubscriptionModalOpen(true);
  };

  const handleCloseSubscriptionModal = () => {
    setIsSubscriptionModalOpen(false);
    setSubscriptionDetails(null);
  };

  const handleOpenMarketplaceModal = (details) => {
    setMarketplaceDetails(details);
    setViewMarketplaceDetailsOpen(true);
  };

  const handleCloseMarketplaceModal = () => {
    setViewMarketplaceDetailsOpen(false);
    setMarketplaceDetails(null);
  };

  const handleOpenWorkloadModal = (accountNumber) => {
    setSelectedAccountNumber(accountNumber);
    setIsWorkloadModalOpen(true);
  };

  const handleCloseWorkloadModal = () => {
    setIsWorkloadModalOpen(false);
    setSelectedAccountNumber(null);
    // Clear workload-related messages when closing modal
    props.clearAllMessages();
  };

  const handleOpenScanScheduleModal = (orgCode, accountCode) => {
    // Find the account to get accountNumber and accountName
    const account = props.orgAccounts?.find(acc => acc.accountCode === accountCode);
    setSelectedOrgCode(orgCode);
    setSelectedAccountCode(accountCode);
    setSelectedScanScheduleAccountNumber(account?.accountNumber || null);
    setSelectedScanScheduleAccountName(account?.accountName || null);
    setIsScanScheduleModalOpen(true);
  };

  const handleCloseScanScheduleModal = () => {
    setIsScanScheduleModalOpen(false);
    setSelectedOrgCode(null);
    setSelectedAccountCode(null);
    setSelectedScanScheduleAccountNumber(null);
    setSelectedScanScheduleAccountName(null);
    // Clear scan schedule-related messages when closing modal
    props.clearAllMessages();
  };

  // Delete confirmation dialog handlers
  const handleDeleteClick = (account) => {
    setAccountToDelete(account);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = () => {
    if (accountToDelete) {
      console.log("delete account: ", accountToDelete.accountCode);
      props.deleteOrgAccount(orgCode, accountToDelete.accountCode);
    }
    setIsDeleteDialogOpen(false);
    setAccountToDelete(null);
  };

  const handleDeleteCancel = () => {
    setIsDeleteDialogOpen(false);
    setAccountToDelete(null);
  };

  console.log("editUserData: ", editUserData);
  const clearAllOrgUserMessages = useCallback(() => {
    props.clearAllOrgUserMessages();
  }, []);

  const handleUpdateAccountClose = () => {
    setIsUpdateAccountOpen(false);
  };

  const handleAddAccountClose = () => {
    setAddOrgAccountIsOpen(false);
  };

  const handleSubscriptionInputChange = (e) => {
    setSubscription(e.target.value);
  };

  const showOrgAccounts = () => {
    document.getElementById("organizationAccountsId").style.display = "block";
    document.getElementById("organizationUsersId").style.display = "none";
    document.getElementById("viewId").textContent = "Accounts";
  };
  const showOrgUsers = () => {
    document.getElementById("organizationUsersId").style.display = "block";
    document.getElementById("organizationAccountsId").style.display = "none";
    document.getElementById("viewId").textContent = "Users";
  };

  useEffect(() => {
    props.getOrgAccounts(orgCode);
    props.getCustomLicenses(orgCode);
    props.getLicense(orgCode);
  }, [orgCode]);

  //For displaying message for getting organization account
  let getOrgAccountsMsg = props.getOrgAccountsMessage;
  let getOrgAccountsErr = props.getOrgAccountsError;
  useEffect(() => {
    console.log("getOrgAccountsMsg = " + getOrgAccountsMsg);
    if (getOrgAccountsMsg || getOrgAccountsErr) {
      console.log("Inside if, getOrgAccountsMsg = " + getOrgAccountsMsg);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [getOrgAccountsMsg, getOrgAccountsErr, props]);

  //For displaying message for deleting organization account
  let deleteOrgAccountMsg = props.deleteOrgAccountMessage;
  let deleteOrgAccountErr = props.deleteOrgAccountError;
  useEffect(() => {
    console.log("deleteOrgAccountMsg = " + deleteOrgAccountMsg);
    if (deleteOrgAccountMsg || deleteOrgAccountErr) {
      console.log("Inside if, deleteOrgAccountMsg = " + deleteOrgAccountMsg);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [deleteOrgAccountMsg, deleteOrgAccountErr, props]);

  // Memoized callbacks to be used within useEffect
  const getOrgAccounts = useCallback(() => {
    props.getOrgAccounts(orgCode);
  }, [orgCode]);

  const clearAllMessages = useCallback(() => {
    props.clearAllMessages();
  }, []);

  //For displaying message for updating organization account
  let updateOrgAccountMsg = props.updateOrgAccountMessage;
  let updateOrgAccountErr = props.updateOrgAccountError;
  useEffect(() => {
    console.log("updateOrgAccountMsg = " + updateOrgAccountMsg);
    if (updateOrgAccountMsg) {
      //Close Modal, only if successful
      setIsUpdateAccountOpen(false);
      getOrgAccounts(orgCode);
    }
    if (updateOrgAccountMsg || updateOrgAccountErr) {
      console.log("Inside if, updateOrgAccountMsg = " + updateOrgAccountMsg);
      //Clear all messages after 10 seconds
      setTimeout(() => {
        clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    updateOrgAccountMsg,
    updateOrgAccountErr,
    getOrgAccounts,
    clearAllMessages,
    orgCode,
  ]);

  //For displaying message for updating organization account
  let addOrgAccountMsg = props.addOrgAccountMessage;
  let addOrgAccountErr = props.addOrgAccountError;
  useEffect(() => {
    console.log("addOrgAccountMsg = " + addOrgAccountMsg);
    if (addOrgAccountMsg) {
      //Close Modal, only if successful
      setAddOrgAccountIsOpen(false);
      getOrgAccounts(orgCode);
    }
    if (addOrgAccountMsg || addOrgAccountErr) {
      console.log("Inside if, addOrgAccountMsg = " + addOrgAccountMsg);
      //Clear all messages after 10 seconds
      setTimeout(() => {
        clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [
    addOrgAccountMsg,
    addOrgAccountErr,
    getOrgAccounts,
    clearAllMessages,
    orgCode,
  ]);

  //For displaying message for deleting organization user
  let deleteOrgUserMsg = props.deleteOrgUserMessage;
  let deleteOrgUserErr = props.deleteOrgUserError;
  useEffect(() => {
    console.log("deleteOrgUserMsg = " + deleteOrgUserMsg);
    if (deleteOrgUserMsg || deleteOrgUserErr) {
      console.log("Inside if, deleteOrgUserMsg = " + deleteOrgUserMsg);
      setTimeout(() => {
        props.clearAllMessages();
      }, 10000); // Hide all messages after 10 seconds
    }
  }, [deleteOrgUserMsg, deleteOrgUserErr, props]);

  //For displaying message for editing org user
  let editOrgUserMessage = props.editOrgUserMessage;
  let editOrgUserError = props.editOrgUserError;
  useEffect(() => {
    console.log("editOrgUserMessage = " + editOrgUserMessage);
    if (editOrgUserMessage || editOrgUserError) {
      console.log("Inside if, editOrgUserMessage = " + editOrgUserMessage);
      // setTimeout(() => {
      clearAllOrgUserMessages();
      // }, 10000); // Hide all messages after 10 seconds
      if (editOrgUserMessage) {
        enqueueSnackbar(editOrgUserMessage, { variant: "success" });
      }
      if (editOrgUserError) {
        enqueueSnackbar(editOrgUserError, { variant: "error" });
      }
    }
  }, [editOrgUserMessage, editOrgUserError, clearAllOrgUserMessages]);

  //For displaying message for creating org user
  let createOrgUserMessage = props.createOrgUserMessage;
  let createOrgUserError = props.createOrgUserError;
  useEffect(() => {
    console.log("createOrgUserMessage = " + createOrgUserMessage);
    if (createOrgUserMessage || createOrgUserError) {
      console.log("Inside if, createOrgUserMessage = " + createOrgUserMessage);
      // setTimeout(() => {
      clearAllOrgUserMessages();
      // }, 10000); // Hide all messages after 10 seconds
      if (createOrgUserMessage) {
        enqueueSnackbar(createOrgUserMessage, { variant: "success" });
      }
      if (createOrgUserError) {
        enqueueSnackbar(createOrgUserError, { variant: "error" });
      }
    }
  }, [createOrgUserMessage, createOrgUserError, clearAllOrgUserMessages]);

  // For showing license names in Update Subscription modal
  const licenses = props?.license;
  console.log("licenses: ", licenses);
  const getLicense = useCallback(() => {
    props.getLicense(orgCode);
  }, [orgCode]);

  const customLicenses = props?.customLicenses;
  console.log("customLicenses: ", customLicenses);
  const getCustomLicenses = useCallback(() => {
    props.getCustomLicenses(orgCode);
  }, [orgCode]);

  useEffect(() => {
    console.log("useEffect for getLicense called");
    if (!licenses && orgCode) {
      console.log("Calling getLicense with orgCode: ", orgCode);
      getLicense(orgCode);
    }
    if (!customLicenses && orgCode) {
      console.log("Calling getCustomLicenses with orgCode: ", orgCode);
      getCustomLicenses(orgCode);
    }
  }, [licenses, getLicense, customLicenses, getCustomLicenses, orgCode]);

  const prepareEditUserData = (userData) => {
    const editUserFormData = {
      firstName: userData.firstname,
      lastName: userData.lastName,
      phoneNumber: userData.phoneNumber,
      email: userData.email,
      // password: "",
      country: userData.country,
      // roles: [...userData.Roles],
      resourceGroups: userData.userGroup.map(
        (resourceGroup) => resourceGroup.resourcename
      ),
    };
    console.log("editUserFormData: ", editUserFormData);
    setEditUserData((prevData) => ({ ...prevData, ...editUserFormData }));
    setEditUserIsOpen(true);
  };

  const handleEditModalClose = () => {
    setEditUserData(null);
  };

  const prepareViewUserGroupData = (userGroups, userName) => {
    console.log("UserGroup Data: ", userGroups);
    setUserGroups([...userGroups]);
    setUserName(userName);
    setViewUserGroupIsOpen(true);
  };

  const handleViewUserGroupModalClose = () => {
    setUserGroups(null);
    setUserName(null);
  };

  const prepareViewResourceGroupData = (resourceGroups, resourceName) => {
    console.log("ResourceGroup Data: ", resourceGroups);
    setResourceGroups([...resourceGroups]);
    setAccountName(resourceName);
    setViewResourceGroupIsOpen(true);
  };

  const handleViewResourceGroupModalClose = () => {
    setResourceGroups(null);
    setAccountName(null);
  };

  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    accountNumber: true,
    accountCode: false,
    accountName: true,
    urlLink: false,
    location: false,
    accounttype: false,
    address: false,
    city: false,
    state: false,
    zip: false,
    country: false,
    email: false,
    phonenumber: false,
    eula: false,
    eulaaccepted: false,
    status: false,
    createdDate: false,
    lastModifiedDate: false,
    listusr: true,
    accountResourceGroups: true,
    subscription: false,
    subscription_status: true,
    subscription_type: true,
    complianceAddOns: true,
    AddOns: true,
    expiration_date: true,
    activation_date: false,
    scan_frequency: true,
    contract_amount: true,
    threshold_amount: true,
    usage_percentage: true,
    marketplaceDetails: true,
    orgId: false,
    islocked: false,
    subscription_modified_date: false,
    wafr: true,
    wafr_workload_limit: true,
    scanSchedules: true,
  });

  const columns = [
    {
      field: "accountNumber",
      headerName: "Cloud Account",
      width: 200,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          {/* Status Dot using FiberManualRecordIcon */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <FiberManualRecordIcon
              style={{
                color: params.row.status === "ACTIVE" ? "green" : "red",
                marginRight: 2,
              }}
            />
            {/* Account Number */}
            {params.value}
            {/* Lock/Unlock Icon */}
            {params.row.islocked ? (
              <LockIcon style={{ color: "red" }} />
            ) : (
              <LockOpenIcon style={{ color: "green" }} />
            )}
          </div>
        </div>
      ),
    },
    { field: "accountCode", headerName: "Account Code", width: 150 },
    { field: "accountName", headerName: "Name", width: 150 },
    { field: "urlLink", headerName: "URL", width: 150 }, // Null in the data, but included for completeness
    { field: "location", headerName: "Location", width: 120 },
    { field: "accounttype", headerName: "Type", width: 100 },
    { field: "address", headerName: "Address", width: 200 },
    { field: "city", headerName: "City", width: 120 },
    { field: "state", headerName: "State", width: 100 },
    { field: "zip", headerName: "ZIP", width: 100 },
    { field: "country", headerName: "Country", width: 100 },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phonenumber", headerName: "Phone Number", width: 150 },
    { field: "eula", headerName: "EULA", width: 150 },
    { field: "eulaaccepted", headerName: "EULA Accepted", width: 150 },
    { field: "status", headerName: "Status", width: 120 },
    { field: "orgId", headerName: "Organization ID", width: 150 }, // For orgId

    {
      field: "islocked",
      headerName: "Is Locked",
      width: 180, // Adjust width to fit the icon and text
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Display Yes/No based on islocked value */}
          <span>{params.value ? "Yes" : "No"}</span>

          {/* Info Icon with Tooltip */}
          <Tooltip title="Disable CloudCatcher Operations for account">
            <Info style={{ cursor: "pointer", color: "#1976d2" }} />
          </Tooltip>
        </div>
      ),
    },

    {
      field: "subscription_modified_date",
      headerName: "Subscription Modified Date",
      width: 250, // Adjust width to accommodate the icon and the date
      renderCell: (params) => {
        const date = params.value
          ? new Date(
              new Date(params.value).getTime() -
                new Date(params.value).getTimezoneOffset() * 60000
            )
          : null;
        const displayDate = date ? date.toLocaleDateString() : "N/A";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {/* Date Display */}
            <span>{displayDate}</span>

            {/* Info Icon with Tooltip */}
            <Tooltip title="Date of conversion from marketplace">
              <Info style={{ cursor: "pointer", color: "#1976d2" }} />
            </Tooltip>
          </div>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 200,
      renderCell: (params) => {
        const date = new Date(
          new Date(params.value).getTime() -
            new Date(params.value).getTimezoneOffset() * 60000
        );
        return date.toLocaleDateString();
      },
    },
    {
      field: "lastModifiedDate",
      headerName: "Last Modified Date",
      width: 200,
      renderCell: (params) => {
        const date = new Date(
          new Date(params.value).getTime() -
            new Date(params.value).getTimezoneOffset() * 60000
        );
        return date.toLocaleDateString();
      },
    },
    {
      field: "listusr",
      headerName: "Users",
      width: 100,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            setUsers(params.row.listusr);
            setViewUserIsOpen(true);
          }}
        >
          {params.row.listusr.length}
        </Button>
      ),
    },
    {
      field: "accountResourceGroups",
      headerName: "Resource Group",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            prepareViewResourceGroupData(params.row.accountResourceGroups);
          }}
        >
          {params.row.accountResourceGroups.length}
        </Button>
      ),
    },
    {
      field: "subscription",
      headerName: "Subscription",
      width: 150,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => handleOpenSubscriptionModal(params.row.subscription)}
        >
          {params.row.subscription.name}
        </Button>
      ),
    },
    {
      field: "subscription_status",
      headerName: "Subscription Status",
      width: 150,
    },
    { field: "subscription_type", headerName: "Subscription Type", width: 150 },
    {
      field: "complianceAddOns",
      headerName: "Compliance Add Ons",
      width: 150,
      renderCell: (params) => {
        // Filter the complianceAddOns where 'enabled' is true
        const enabledAddOns = params.row.complianceAddOns.filter(addon => addon.enabled);  
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setAddons(params.row.complianceAddOns);
              setOrgAccountCode(params.row.accountCode);
              setViewComplianceAddOnsIsOpen(true);
            }}
          >
            {enabledAddOns.length} {/* Only show the count of enabled add-ons */}
          </Button>
        );
      }
    },
    {
      field: "AddOns",
      headerName: "Add Ons",
      width: 150,
      renderCell: (params) => {
        // Filter the addons where 'enabled' is true
        const enabledAddOns = params.row.subscription.addons.filter(addon => addon.enabled);
        
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => {
              setAdditionalAddons(params.row.subscription.addons);
              setOrgAccountCode(params.row.accountCode);
              setViewAddOnsIsOpen(true);
            }}
          >
            {enabledAddOns.length} {/* Only show the count of enabled add-ons */}
          </Button>
        );
      }
    },
    {
      field: "contract_amount",
      headerName: "Contract Amount ($)", // must be string!
      width: 220, // Adjusted to accommodate icon and text
      // renderHeader: (params) => (
      //   <div>
      //     Contract Amount ($)
      //     {/* Info Icon with Tooltip */}
      //     <Tooltip title="Total contract amount owed/paid">
      //       <Info style={{ cursor: "pointer", color: "#1976d2" }} />
      //     </Tooltip>
      //   </div>
      // ),
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Contract Amount Display */}
          <span>{`${params.value}`}</span>
        </div>
      ),
    },
    {
      field: "payment_term",
      headerName: "Payment Term",
      width: 150,
      renderCell: (params) => (params.value ? params.value : "N/A"),
    },    
    {
      field: "threshold_amount",
      headerName: "Threshold Amount ($)",
      width: 250, // Adjust width to fit the icon and text
      // renderHeader: (params) => (
      //   <div>
      //     Threshold Amount ($)
      //     {/* Info Icon with Tooltip */}
      //     <Tooltip title="Threshold value to calculate usage">
      //       <Info style={{ cursor: "pointer", color: "#1976d2" }} />
      //     </Tooltip>
      //   </div>
      // ),
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Threshold Amount Display */}
          <span>{`${params.value}`}</span>
        </div>
      ),
    },
    {
      field: "usage_percentage",
      headerName: "Overage Percentage (%)",
      width: 250, // Adjust width to accommodate the icon and text
      // renderHeader: (params) => (
      //   <div>
      //     Overage Percentage (%)
      //     {/* Info Icon with Tooltip */}
      //     <Tooltip title="Cloud spend percentage to calculate usage">
      //       <Info style={{ cursor: "pointer", color: "#1976d2" }} />
      //     </Tooltip>
      //   </div>
      // ),
      renderCell: (params) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          {/* Usage Percentage Display */}
          <span>{`${params.value}`}</span>
        </div>
      ),
    },
    // {
    //   field: "scan_frequency",
    //   headerName: "Scan Frequency",
    //   width: 150,
    // },
    {
      field: "expiration_date",
      headerName: "Expiration Date",
      width: 200,
      renderCell: (params) => {
        if (!params.value) return "N/A";
        const date = new Date(
          new Date(params.value).getTime() -
            new Date(params.value).getTimezoneOffset() * 60000
        );
        return date.toLocaleDateString();
      },
    },
    {
      field: "activation_date",
      headerName: "Activation Date",
      width: 200,
      renderCell: (params) => {
        const date = new Date(
          new Date(params.value).getTime() -
            new Date(params.value).getTimezoneOffset() * 60000
        );
        return date.toLocaleDateString();
      },
    },

    {
      field: "marketplaceDetails",
      headerName: "Marketplace Details",
      width: 180,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            setMarketplaceDetails(params.row.marketplaceDetails);
            setViewMarketplaceDetailsOpen(true);
          }}
        >
          View Details
        </Button>
      ),
    },
    {
      field: "wafr",
      headerName: "WAFR",
      width: 100,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            handleOpenWorkloadModal(params.row.accountNumber);
          }}
          title="Configure WAFR"
        >
          <SettingsIcon />
        </IconButton>
      ),
    },
    {
      field: "wafr_workload_limit",
      headerName: "Workload Limit",
      width: 150,
    },
    {
      field: "scanSchedules",
      headerName: "Scan Schedules",
      width: 150,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          size="small"
          onClick={() => {
            handleOpenScanScheduleModal(orgCode, params.row.accountCode);
          }}
          title="View Scan Schedules"
        >
          <SettingsIcon />
        </IconButton>
      ),
    },
    {
      field: "edit",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={() => {
            const subsc = params.row.subscription?.name || "";
            setOrgAccountCode(params.row.accountCode);
            const expirationDate = new Date(params.row.expiration_date);
            setSubscriptionExpirationDate(expirationDate);
            setSubscription(subsc);
            setIsUpdateAccountOpen(true);
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "delete",
      headerName: "",
      width: 50,
      renderCell: (params) => (
        <IconButton
          color="secondary"
          onClick={() => handleDeleteClick(params.row)}
        >
          <DeleteIcon />
        </IconButton>
      ),
    },
  ];

  const usersColumns = [
    { field: "firstname", headerName: "First Name", width: 100 },
    { field: "lastName", headerName: "Last Name", width: 100 },
    { field: "username", headerName: "User Name", width: 200 },
    {
      field: "isDeleted",
      headerName: "Deleted",
      width: 100,
      renderCell: (params) => {
        if (!params.row.IsDeleted)
          return <div style={{ fontFace: "bold", color: "#193A6F" }}>No</div>;
        else return <div style={{ fontFace: "bold", color: "red" }}>Yes</div>;
      },
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      renderCell: (params) => {
        if (params.row.status)
          return (
            <div style={{ fontFace: "bold", color: "#193A6F" }}>Active</div>
          );
        else
          return <div style={{ fontFace: "bold", color: "red" }}>Inactive</div>;
      },
    },
    { field: "email", headerName: "Email", width: 200 },
    { field: "phoneNumber", headerName: "Phone Number", width: 150 },
    {
      field: "roles",
      headerName: "Roles",
      width: 100,
      renderCell: (params) => {
        const roles = params.row.roles.map((roleName, index) => {
          if (params.row.roles.length - 1 === index) {
            return roleName;
          } else {
            return roleName + ", ";
          }
        });
        return roles;
      },
    },
    {
      field: "userGroup",
      headerName: "User Groups",
      width: 150,
      renderCell: (params) => {
        // const groups = params.row.UserGroup.map((userGroup, index) => {
        //   if (params.row.UserGroup.length - 1 === index) {
        //     return userGroup.resourcename;
        //   } else {
        //     return userGroup.resourcename + ", ";
        //   }
        // });
        // return groups;
        return (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            onClick={() => {
              prepareViewUserGroupData(
                params.row.userGroup,
                params.row.username
              );
            }}
          >
            {params.row.userGroup.length}
          </Button>
        );
      },
    },
    {
      field: "createdDate",
      headerName: "Creation Date",
      width: 200,
      renderCell: (params) => {
        const browserDate = convertToBrowserDateAsDate(params.row.createdDate);
        const dateInBrowserTimeZone = browserDate.toLocaleString(
          undefined,
          dateOptions
        );

        return <>{params.row.createdDate ? dateInBrowserTimeZone : ""}</>;
      },
    },
    {
      field: "edit",
      headerName: "Edit User",
      width: 100,
      renderCell: (params) => (
        <IconButton
          variant="contained"
          color="primary"
          onClick={() => {
            console.log("edit user ", params.row);
            prepareEditUserData(params.row);
          }}
        >
          <EditIcon />
        </IconButton>
      ),
    },
    {
      field: "delete",
      headerName: "Delete",
      width: 100,
      renderCell: (params) => {
        // Check if the user is an admin
        if (userRole.includes("Admin")) {
          return (
            <IconButton
              color="secondary"
              onClick={() => {
                console.log("~ params.row = ", params.row);
                props.deleteOrgUser(orgCode, params.row.email);
              }}
              disabled={params.row.IsDeleted}
            >
              <DeleteIcon />
            </IconButton>
          );
        } else {
          return (
            <IconButton color="secondary" disabled className="Mui-disabled">
              <DeleteIcon />
            </IconButton>
          );
        }
      },
    },
  ];

  return (
    <SnackbarProvider maxSnack={3}>
      <div>
        <AppBar position="static" style={appBarStyles}>
          <Toolbar>
            <Breadcrumbs aria-label="breadcrumb" sx={{ flexGrow: 1 }}>
              <Link component={RouterLink} to="/organization" color="inherit">
                <HomeOutlinedIcon />
              </Link>
              {props?.organization?.orgname ? (
                <Chip 
                  label={props?.organization?.orgname} 
                  color="primary"
                />
              ) : (
                <Typography color="textPrimary">
                  <Link component={RouterLink} to="/organization" color="inherit">
                    Organization
                  </Link>
                </Typography>
              )}
              <Typography color="textPrimary">
                <span id="viewId">Accounts</span>
              </Typography>
            </Breadcrumbs>
            <div>
              <Button
                onClick={showOrgAccounts}
                style={{ color: "blue", padding: "1rem" }}
              >
                Show Accounts
              </Button>
              <Button
                onClick={showOrgUsers}
                style={{ color: "blue", padding: "1rem" }}
              >
                Show Users
              </Button>
            </div>
          </Toolbar>
        </AppBar>

        {/* Organization Accounts */}
        <div id="organizationAccountsId">
          <h1>List of Organization Accounts</h1>
          {/* Status Messages */}
          {props.isGettingOrgAccounts && (
            <LoadingSpinner />
          )}
          {props.isDeletingOrgAccount && (
            <LoadingSpinner />
          )}
          {props.getOrgAccountsMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.getOrgAccountsMessage}
            </Alert>
          )}
          {props.getOrgAccountsError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while getting organization accounts.
              {JSON.stringify(props.getOrgAccountsError?.message)}
            </Alert>
          )}
          {props.deleteOrgAccountMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.deleteOrgAccountMessage}
            </Alert>
          )}
          {props.deleteOrgAccountError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while deleting organization account.
              {JSON.stringify(props.deleteOrgAccountError?.message)}
            </Alert>
          )}
          {props.updateOrgAccountMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.updateOrgAccountMessage}
            </Alert>
          )}
          {props.addOrgAccountMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.addOrgAccountMessage}
            </Alert>
          )}

          {/* Data grid/table to display organization accounts */}
          {props.orgAccounts && (
            // <div style={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={props.orgAccounts}
              columns={columns}
              pageSize={5}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
              autoHeight
              getRowId={(row) => row.id}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                setColumnVisibilityModel(newModel)
              }
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 15, page: 0 },
                },
              }}
              density="compact"
            />
            // </div>
          )}

          {addOrgAccountIsOpen && (
            <AddOrganizationAccount
              orgCode={orgCode}
              open={addOrgAccountIsOpen}
              onClose={handleAddAccountClose}
              resourceGroups={props?.organization?.resourceGroups}
            />
          )}

          {/* Modal to show Users */}
          <UserModal
            isOpen={viewUserIsOpen}
            setOpen={setViewUserIsOpen}
            users={users}
          />

          {/* Modal to show Compliance Add Ons */}
          {viewComplianceAddOnsIsOpen && (
            <ComplianceAddOnsModal
              isOpen={viewComplianceAddOnsIsOpen}
              setOpen={setViewComplianceAddOnsIsOpen}
              addons={addons}
              updateOrgAccountMessage={props.updateOrgAccountMessage}
              updateOrgAccountError={props.updateOrgAccountError}
              isUpdatingOrgAccount={props.isUpdatingOrgAccount}
              updateOrgAccount={props.updateOrgAccount}
              orgAccountCode={orgAccountCode}
              account={props?.orgAccounts?.find(
                (orgAccount) => orgAccount.accountCode === orgAccountCode
              )}
              additionalAddons={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.subscription?.addons
              }
              subscription={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.subscription?.name
              }
              expiration_date={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.expiration_date
              }
              subscription_type={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.subscription_type
              }
              resourceGroup={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.accountResourceGroups[0]?.resourcename
              }
            />
          )}

          {/* Modal to Show Additional Addons */}
          {viewAddonsIsOpen && (
            <AdditionalAddonsModal
              isOpen={viewAddonsIsOpen}
              setOpen={setViewAddOnsIsOpen}
              addons={additionalAddons}
              updateOrgAccountMessage={props.updateOrgAccountMessage}
              updateOrgAccountError={props.updateOrgAccountError}
              isUpdatingOrgAccount={props.isUpdatingOrgAccount}
              updateOrgAccount={props.updateOrgAccount}
              orgAccountCode={orgAccountCode}
              complianceAddOns={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.complianceAddOns
              }
              subscription={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.subscription?.name
              }
              expiration_date={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.expiration_date
              }
              subscription_type={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.subscription_type
              }
              account={props?.orgAccounts?.find(
                (orgAccount) => orgAccount.accountCode === orgAccountCode
              )}
              resourceGroup={
                props.orgAccounts?.find(
                  (orgAccount) => orgAccount.accountCode === orgAccountCode
                )?.accountResourceGroups[0]?.resourcename
              }
              allAccounts={props.orgAccounts}
            />
          )}

          {/* Modal to add an account */}

          {/* Modal to update an account, subscription */}
          {isUpdateAccountOpen && (
            <UpdateOrganizationAccount
              open={isUpdateAccountOpen}
              onClose={handleUpdateAccountClose}
              licenses={licenses}
              customLicenses={customLicenses}
              orgAccountCode={orgAccountCode}
              account={props?.orgAccounts?.find(
                (account) => account.accountCode === orgAccountCode
              )}
              resourceGroups={props?.organization?.resourceGroups}
            />
          )}

          {/* AWS Marketplace Modal */}
          {isMarketplaceModalOpen && (
            <AWSMarketplaceModal
              open={isMarketplaceModalOpen}
              onClose={handleCloseMarketplaceModal}
              marketplaceDetails={marketplaceDetails}
            />
          )}

          {isSubscriptionModalOpen && (
            <SubscriptionModal
              open={isSubscriptionModalOpen}
              onClose={handleCloseSubscriptionModal}
              subscription={subscriptionDetails}
            />
          )}

          {/* Workload Modal */}
          {isWorkloadModalOpen && (
            <WorkloadModal
              open={isWorkloadModalOpen}
              onClose={handleCloseWorkloadModal}
              accountNumber={selectedAccountNumber}
              workloads={props.workloads}
              isGettingWorkloads={props.isGettingWorkloads}
              getWorkloadsError={props.getWorkloadsError}
              getWorkloadsMessage={props.getWorkloadsMessage}
              getOrgAccountWorkloads={props.getOrgAccountWorkloads}
              updateWorkload={props.updateWorkload}
              isUpdatingWorkload={props.isUpdatingWorkload}
              updateWorkloadError={props.updateWorkloadError}
              updateWorkloadMessage={props.updateWorkloadMessage}
            />
          )}

          {/* Scan Schedule Modal */}
          {isScanScheduleModalOpen && (
            <ScanScheduleModal
              open={isScanScheduleModalOpen}
              onClose={handleCloseScanScheduleModal}
              orgCode={selectedOrgCode}
              accountCode={selectedAccountCode}
              accountNumber={selectedScanScheduleAccountNumber}
              accountName={selectedScanScheduleAccountName}
              scanSchedules={props.scanSchedules}
              isGettingScanSchedules={props.isGettingScanSchedules}
              getScanSchedulesError={props.getScanSchedulesError}
              getScanSchedulesMessage={props.getScanSchedulesMessage}
              getScanSchedules={props.getScanSchedules}
              updateScanScheduleFrequency={props.updateScanScheduleFrequency}
              isUpdatingScanSchedule={props.isUpdatingScanSchedule}
              updateScanScheduleError={props.updateScanScheduleError}
              updateScanScheduleMessage={props.updateScanScheduleMessage}
              orgAccounts={props.orgAccounts}
              getOrgAccounts={props.getOrgAccounts}
            />
          )}
        </div>

        {/* Organization Users */}
        <div id="organizationUsersId" style={{ display: "none" }}>
          <h1>List of Organization Users</h1>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddCircleIcon />}
            onClick={() => {
              setAddUserIsOpen(true);
            }}
            disabled={
              !props.organization ||
              !props.organization.resourceGroups ||
              props.organization.resourceGroups.length === 0
            }
          >
            Add a new User
          </Button>
          {/* <IconButton
              variant="contained"
              color="primary"
              onClick={ () => { setAddUserIsOpen(true); } }
            >
              <AddCircleIcon /> 
            </IconButton> 
            Add a new Support User */}
          {/* Status Messages */}
          {props.isGettingOrgAccounts && (
            <LoadingSpinner />
          )}
          {props.isDeletingOrgUser && (
            <LoadingSpinner />
          )}
          {props.deleteOrgUserMessage && (
            <Alert className="mt-3 mb-0" color="success">
              {props.deleteOrgUserMessage}
            </Alert>
          )}
          {props.deleteOrgUserError && (
            <Alert className="mt-3 mb-0" color="danger">
              Error while deleting organization user.
              {JSON.stringify(props.deleteOrgUserError?.message)}
            </Alert>
          )}
          {/* Data grid/table to display organization users */}
          {props.orgUsers && (
            <DataGrid
              rows={props.orgUsers}
              // rows={organizations}
              columns={usersColumns}
              pageSize={30}
              components={{
                Toolbar: GridToolbar,
              }}
              disableSelectionOnClick
              autoHeight
              disableColumnMenu
              disableColumnSelector
              getRowId={(row) => row.email}
            />
          )}
          {/* Modal to Add User */}
          {addUserIsOpen && (
            <AddUserModal
              orgCode={orgCode}
              resourceGroups={props.organization.resourceGroups?.map(
                (resource) => resource.resourcename
              )}
              billingEmail={props.organization.orgbillingemail}
              isOpen={addUserIsOpen}
              setOpen={setAddUserIsOpen}
            />
          )}
          {/* Modal to Edit User */}
          {editUserData && (
            <EditUserModal
              orgCode={orgCode}
              resourceGroups={props.organization.resourceGroups.map(
                (resource) => resource.resourcename
              )}
              isOpen={editUserIsOpen}
              setOpen={setEditUserIsOpen}
              editUserData={editUserData}
              handleModalClose={handleEditModalClose}
            />
          )}
          {/* Modal to Show ResourceGroups */}
          {userGroups && (
            <UserGroupModal
              userGroups={userGroups}
              userName={userName}
              isOpen={viewUserGroupIsOpen}
              setOpen={setViewUserGroupIsOpen}
              handleModalClose={handleViewUserGroupModalClose}
            />
          )}

          {/* Modal to Show ResourceGroups */}
          {resourceGroups && (
            <ResourceGroupModal
              resourceGroups={resourceGroups}
              accountName={accountName}
              isOpen={viewResourceGroupIsOpen}
              setOpen={setViewResourceGroupIsOpen}
              handleModalClose={handleViewResourceGroupModalClose}
            />
          )}
        </div>

        {/* Delete Confirmation Dialog */}
        <Dialog
          open={isDeleteDialogOpen}
          onClose={handleDeleteCancel}
          aria-labelledby="delete-confirmation-dialog"
        >
          <DialogTitle id="delete-confirmation-dialog">
            Confirm Delete Account
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete the account <strong>{accountToDelete?.accountName}</strong> (Account Code: <strong>{accountToDelete?.accountCode}</strong>)?
              <br />
              This action cannot be undone.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel} color="primary">
              Cancel
            </Button>
            <Button
              onClick={handleDeleteConfirm}
              color="secondary"
              variant="contained"
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </SnackbarProvider>
  );
};

const mapStateToProps = (state) => {
  const {
    orgAccounts,
    orgUsers,
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

    isUpdatingOrgAccount,
    updateOrgAccountError,
    updateOrgAccountMessage,

    addOrgAccountError,
    addOrgAccountMessage,

    isDeletingOrgAccount,
    deleteOrgAccountError,
    deleteOrgAccountMessage,

    isDeletingOrgUser,
    deleteOrgUserError,
    deleteOrgUserMessage,

    // Workload states
    workloads,
    isGettingWorkloads,
    getWorkloadsError,
    getWorkloadsMessage,

    // Update workload states
    isUpdatingWorkload,
    updateWorkloadError,
    updateWorkloadMessage,

    // Scan schedules states
    scanSchedules,
    isGettingScanSchedules,
    getScanSchedulesError,
    getScanSchedulesMessage,

    // Update scan schedule states
    isUpdatingScanSchedule,
    updateScanScheduleError,
    updateScanScheduleMessage,
  } = state.orgAccount;

  const {
    editOrgUserMessage,
    editOrgUserError,
    createOrgUserMessage,
    createOrgUserError,
  } = state.orgUsers;

  const { isGettingLicense, getLicenseError, getLicenseMessage, license } =
    state.globalLicense;

  const {
    isGettingCustomLicense,
    getCustomLicensesError,
    getCustomLicensesMessage,
    customLicenses,
  } = state.customLicense;

  return {
    orgAccounts,
    orgUsers,
    organization,

    isGettingOrgAccounts,
    getOrgAccountsError,
    getOrgAccountsMessage,

    isUpdatingOrgAccount,
    updateOrgAccountError,
    updateOrgAccountMessage,

    addOrgAccountError,
    addOrgAccountMessage,

    isDeletingOrgAccount,
    deleteOrgAccountError,
    deleteOrgAccountMessage,

    isDeletingOrgUser,
    deleteOrgUserError,
    deleteOrgUserMessage,

    editOrgUserMessage,
    editOrgUserError,
    createOrgUserMessage,
    createOrgUserError,

    isGettingLicense,
    getLicenseError,
    getLicenseMessage,
    license,

    isGettingCustomLicense,
    getCustomLicensesError,
    getCustomLicensesMessage,
    customLicenses,

    // Workload props
    workloads,
    isGettingWorkloads,
    getWorkloadsError,
    getWorkloadsMessage,

    // Update workload props
    isUpdatingWorkload,
    updateWorkloadError,
    updateWorkloadMessage,

    // Scan schedules props
    scanSchedules,
    isGettingScanSchedules,
    getScanSchedulesError,
    getScanSchedulesMessage,

    // Update scan schedule props
    isUpdatingScanSchedule,
    updateScanScheduleError,
    updateScanScheduleMessage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOrgAccounts: (orgCode) => {
      dispatch(getOrgAccounts(orgCode));
    },
    updateOrgAccount: (orgAccountCode, subscription) => {
      dispatch(updateOrgAccount(orgAccountCode, subscription));
    },
    deleteOrgAccount: (orgCode, orgAccountCode) => {
      dispatch(deleteOrgAccount(orgCode, orgAccountCode));
    },
    deleteOrgUser: (orgCode, username) => {
      dispatch(deleteOrgUser(orgCode, username));
    },
    clearAllMessages: () => {
      dispatch(clearAllOrgAcctMessages());
    },
    clearAllOrgUserMessages: () => {
      dispatch(clearAllOrgUserMessages());
    },
    getLicense: (orgCode) => {
      dispatch(getLicense(orgCode));
    },
    clearAllGlobalLicenseMessages: () => {
      dispatch(clearAllGlobalLicenseMessages());
    },
    getCustomLicenses: (orgCode) => {
      dispatch(getCustomLicenses(orgCode));
    },
    clearAllCustomLicenseMessages: () => {
      dispatch(clearAllCustomLicenseMessages());
    },
    getOrgAccountWorkloads: (accountNumber) => {
      dispatch(getOrgAccountWorkloads(accountNumber));
    },
    updateWorkload: (accountNumber, workloadId, automationRunLimitPerDay) => {
      dispatch(updateOrgAccountWorkload(accountNumber, workloadId, automationRunLimitPerDay));
    },
    getScanSchedules: (orgCode, accountCode) => {
      dispatch(getScanSchedules(orgCode, accountCode));
    },
    updateScanScheduleFrequency: (orgCode, accountCode, scheduleId, frequency, status, auditScanLimit) => {
      dispatch(updateScanScheduleFrequency(orgCode, accountCode, scheduleId, frequency, status, auditScanLimit));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationAccount);
